import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';


export default function Userloan(){
    const navigate = useNavigate();
    const date = new Date().toISOString().slice(0,10);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [userid, setUserid]= useState(0);
    const [user, setUser] = useState([]);
    const[userconf,setUserconf] = useState([]);
    const authorizeid = localStorage.getItem("userid") ;
    const[checked,setChecked] = useState(false);
const[username,setUsername] = useState([]);
    const APP_NAME = process.env.REACT_APP_NAME;
    const [settings, setSettings] = useState([]);

    useEffect(()=>
    {
        fetch(API_URL+"api/Userloan/GetLoanStatus?userid="+ userid)
        .then(response => response.json()).then(data => {setUser(data)});

        fetch(API_URL+"api/User/GetUserId?userid="+userid)
        .then(response => response.json()).then(data =>{setUserconf(data)});
	
	    fetch(API_URL+"api/User/GetUser")
        .then(response => response.json()).then(data =>{setUsername(data)});

        fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
        .then(res=>res.json())
        .then((data)=>{setSettings(data)});

    },[userid])

console.log(user)
console.log(userconf);
console.log(userid);

function loaduser()
    {
        setUserid(parseInt(document.getElementById('userid').value));
        var usrid = parseInt(document.getElementById('userid').value);
        console.log(usrid);

        var finduser = username.filter((e) => {if(e.UserID === usrid) return e});

        console.log(finduser);

        if(finduser.length > 0)
        {
            document.getElementById('username').value = finduser[0].UserName;
        }
        else
        {
            document.getElementById('username').value = ' '
        }

    }


async function enterloan()
   {
        var userloanid = settings[0].UserLoanID + 1;
        var entdate = date;
        var fordate = document.getElementById('fdate').value;
        var lamount = document.getElementById('amount').value;
       

        var data = new FormData();
        data.append("userloanid",userloanid);
        data.append("userid",userid);
        data.append("entdate",entdate);
        data.append("fordate",fordate);
        data.append("lamount",lamount);
        data.append("authid",authorizeid);
        
        if(user.length === 0 )
        {

            if(userconf.length === 0)
            {
               validIDdialog();
            }
            else
            {
                if (fordate < entdate)
                {
                    fordatedialog();
                }
                else
                {
                fetch(API_URL+"api/Userloan/EnterUserLoan",{method:"POST", body:data })
                .then(response => response.json())
                .then(()=>{});

                fetch(API_URL+"api/Userloan/IncrementUserLoanID?id="+userloanid,{method:"PUT",body:null})
                .then(response=>response.json())
                .then(()=>{});

                

                loanamtcreditedDialog();
                }
                
            }
        }
       else if(user.length > 0 && user[0].LoanReturned === 1)
        {
            if (fordate < entdate)
                {
                    fordatedialog();
                }
            else
                {
                     fetch(API_URL+"api/Userloan/EnterUserLoan",{method:"POST", body:data})
                     .then(response => response.json())
                     .then(()=>{});

                     fetch(API_URL+"api/Userloan/IncrementUserLoanID?id="+userloanid,{method:"PUT",body:null})
                    .then(response=>response.json())
                    .then(()=>{});

                     loanamtcreditedDialog();
                }
        }
        
        else if (user.length > 0 && user[0].LoanReturned === 0)
        {
            loannotclosedDialog();
        }
   } 

function validIDdialog()
{
  const dialog = document.getElementById('valididDialog');
  dialog.showModal();
}
function closeIDdialog()
{
  const dialog = document.getElementById('valididDialog');
  dialog.close();
}

function loannotclosedDialog()
{
  const dialog = document.getElementById('loannotclosedDialog');
  dialog.showModal();
}
function loanamtcreditedDialog()
{
  const dialog = document.getElementById('loanamtcreditedDialog');
  dialog.showModal();
}
function fordatedialog()
{
  const dialog = document.getElementById('fordateDialog');
  dialog.showModal();
}
function closefordatedialog()
{
  const dialog = document.getElementById('fordateDialog');
  dialog.close();
}
    return(
        <>
        <div className="reportheader"> {APP_NAME}
            
            <Navbar/>
        </div> 
        <div style={{backgroundColor:"goldenrod",height:"25px",width:"100%",textAlign:"center",zIndex:-1,marginBottom:"20px"}}>UserLoan</div>
        
        <div>
            <label for ="userid" style ={{marginLeft:"75px"}}>User ID</label>
            <input id = "userid" onChange={()=>{loaduser()}} style ={{marginLeft:"10px",width:"170px",height: "30px"}}></input><br/><br/>
	<label for ="username" style ={{marginLeft:"50px"}}>User Name</label>
            <input id = "username" style ={{marginLeft:"10px",width:"170px",height: "30px"}} readOnly></input><br/><br/>
            <label for = "edate" style ={{marginLeft:"55px"}}>Entry Date</label>
            <input id = "edate" type="date" value = {date} style ={{marginLeft:"10px",width:"170px",height: "30px"}} readOnly></input><br/><br/>
            <label for = "fdate"  style ={{marginLeft:"67px"}}>For Date</label>
            <input id = "fdate" type="date" defaultValue={date} style ={{marginLeft:"10px",width:"170px",height: "30px"}}></input><br/><br/>
            <label for = "amount" style ={{marginLeft:"5px"}}>Opening Amount</label>
            <input id = "amount" defaultValue ='0' style ={{marginLeft:"10px",height: "30px"}}></input><br/><br/>
            
        </div>
        
        <div style ={{marginTop:"50px"}}>

        
        <button type = "button"  className='actionbuttons' onClick={()=>{enterloan()}}>OK</button> 
        <button type = "button"  className='actionbuttons' style ={{backgroundColor:"red"}} onClick={()=>{navigate('/user')}}>Cancel</button>
        </div>
        <dialog id = "valididDialog" className="okdialog">
            <p>Please Enter Valid ID</p>
            <button className="okdialogbutton" onClick={()=>{closeIDdialog()}}>OK</button>
        </dialog>

        <dialog id = "loannotclosedDialog" className="okdialog">
            <p>Previous Loan STILL NOT CLOSED</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/user')}}>OK</button>
        </dialog>

        <dialog id = "loanamtcreditedDialog" className="okdialog">
            <p>Loan Amount Credited to UserID  : {userid}</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/user')}}>OK</button>
        </dialog>
        <dialog id = "fordateDialog" className="okdialog">
            <p>For Date Should Not be Less than Current Date</p>
            <button className="okdialogbutton" onClick={()=>{closefordatedialog()}}>OK</button>
        </dialog>
        </>
    )
}